import { render, staticRenderFns } from "./UploadFilesLgInner.vue?vue&type=template&id=1352c295&scoped=true"
import script from "./UploadFilesLgInner.vue?vue&type=script&lang=js"
export * from "./UploadFilesLgInner.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesLgInner.vue?vue&type=style&index=0&id=1352c295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352c295",
  null
  
)

export default component.exports